import styled from 'styled-components';
import { Button } from '@dealstack/frontend/shared/components/fundament/Button/Button';

export const Inputlabel = styled.div`
	font-family: 'Inter', sans-serif;
	font-weight: 700;
	font-size: 9px;
	color: #7b8991;
`;

export const PersonalInputsWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1em;
	max-width: 50%;
`;

export const ActionButton = styled(Button)``;

export const DeleteButton = styled(Button)`
	margin-top: 1rem;
	width: 50%;
`;
